import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FC, useMemo } from 'react';
import Box from '@mui/material/Box';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { Iconify } from '@mgm/common/components';
import { BaseTooltip, SoftButton } from '@mgm/common/components/base';
import { useCommissions } from '../../../hooks/useCommissions';
import { commissionsActions } from '../../../store/commissions/slice';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppStore';
import { getMembers } from '../../../store/team/selectors';
import { useCommissionPlansPermissions } from '../hooks/useCommissionPlansPermissions';
import { ROUTES } from '../../../data';

type TCommissionPlansMainHeader = {
  handleStartTour: () => void
};

const CommissionPlansMainHeader: FC<TCommissionPlansMainHeader> = ({ handleStartTour }) => {
  const { createCommission } = useCommissions();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const members = useAppSelector(getMembers);
  const { t } = useTranslation(['commissions', 'common']);
  const { commissionPlansPermissions } = useCommissionPlansPermissions();

  const goToAssign = () => {
    navigate(ROUTES.COMMISSION_SALES);
  };

  const onOpenAssignMembers = () => {
    dispatch(commissionsActions.setIsOpenAssignMembersNav(true));
  };

  const isAssignMemberDisable = useMemo(() => {
    const filteredMembers = members?.filter((member) => member.commissionPlan?.name);

    return filteredMembers.length === members.length;
  }, [members]);

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {!isMobile && (
      <BaseTooltip tooltipText={t('clockHereToStartAGuided', { ns: 'common' })}>
        <Box
          sx={{
            cursor: 'pointer',
          }}
          alignItems="center"
          display="flex"
          onClick={handleStartTour}
        >
          <Iconify icon="cuida:help-outline" width={24} sx={{ color: '#A855F7' }} />
        </Box>
      </BaseTooltip>
      )}
      {commissionPlansPermissions.isAllowManage && (
        <SoftButton
          id="assign-plans"
          fullWidth={isMobile}
          onClick={onOpenAssignMembers}
          background={theme.palette.primary.main}
          disabled={isAssignMemberDisable}
        >
          {t('assignPlans')}
        </SoftButton>
      )}
      {commissionPlansPermissions.isAllowManage && (
      <Button
        id="assign-orders"
        fullWidth={isMobile}
        onClick={goToAssign}
        variant="outlined"
      >
        {t('assignOrders')}
      </Button>
      )}
      {commissionPlansPermissions.isAllowManage && (
      <Button
        id="create-new-plan"
        fullWidth={isMobile}
        onClick={createCommission}
        variant="contained"
      >
        {t('createNewPlan')}
      </Button>
      )}
    </Stack>

  );
};

export {
  CommissionPlansMainHeader,
};
